import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type FilterListOffProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function FilterListOff(props: FilterListOffProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="FilterListOffIcon"
      style={style}
    >
      <path d="M10.83 8H21V6H8.83zm5 5H18v-2h-4.17zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41z" />
    </svg>
  )
}
